module.exports = __webpack_public_path__ + "img/shield.bcf29923.svg";